<template>
  <div class="toggle">
    <input
      type="radio"
      :id="id + '-on'"
      class="toggle__input toggle__input--left"
      :name="name"
      v-model="picked"
      :value="toggleOnValue" @change="updateInput">

    <label :for="id + '-on'" class="toggle__label">{{ toggleOnLabel }}</label>
    <input
      type="radio"
      :id="id + '-off'"
      class="toggle__input toggle__input--right"
      :name="name"
      v-model="picked"
      :value="toggleOffValue" @change="updateInput">
    <label :for="id + '-off'" class="toggle__label">{{ toggleOffLabel }}</label>
  </div>
</template>

<script>
export default {
  name: "toggle-switch",
  model: {
    prop: 'name',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
      description: "ID of toggle switch to make it unique"
    },
    toggleOnLabel: {
      type: String,
      required: true,
      description: "Label of toggle on input"
    },
    toggleOffLabel: {
      type: String,
      required: true,
      description: "Label of toggle off input"
    },
    toggleOnValue: {
      required: true,
      description: "Value of toggle on input"
    },
    toggleOffValue: {
      required: true,
      description: "Value of toggle off input"
    },
    selected: {
      required: true,
      description: "Value of toggled on input"
    },
  },
  data() {
    return {
      picked: this.selected
    }
  },
  methods: {
    updateInput(event) {
      this.$emit('input', event.target.value);
    }
  }
}
</script>

<style scoped lang="scss">
.toggle {
  display: flex;
  //margin-right: 4rem;
}

input[type="radio"].toggle__input {
  display: none;

  & + label {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $border;
    cursor: pointer;
    min-width: 50%;
    min-height: 40px;
    text-align: center;
    position: relative;
    font-size: $font-size-xs;
    color: $color-text-gray;

    @include lg {
      //font-size: 1.75rem;
    }

    @include rwd(992) {
      font-size: .9rem;
      min-height: 45px;
    }
  }

  &.toggle__input--left + label {
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
    border-right: 0;
  }

  &.toggle__input--right + label {
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  &:checked + label {
    cursor: default;
    color: $white;
    transition: color 100ms;
    background: $primary;
  }
}
</style>
